import { FunctionalComponent, h } from 'preact';

import { media } from '../../styles';
import styled from 'styled-components';

type Props = {
  ariaLabel?: string;
  minHeight?: number;
  useBackgroundColor: boolean;
  withFadingTop?: boolean;
  withFadingBottom?: boolean;
};

const VerticalScrollerWrapper = styled.div<Props>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  z-index: 1;
  ${({ theme, useBackgroundColor }) =>
    useBackgroundColor
      ? `background-color: ${theme.ui.layer.backgroundColor}`
      : `background-color: ${theme.ui.secondLayer.content.backgroundColor}`};
  ${media.ie11} {
    /* IE10+ CSS styles go here */
    height: auto;
    max-height: 70%;
    min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : '80px')};
    overflow: auto;
    -ms-flex: 1 1 100%;
  }

  ${media.mobilePortrait} {
    overflow: auto;
  }

  ${media.mobileLandscape} {
    overflow: auto;
  }

  ${media.mobilePortraitXS} {
    max-height: initial;
    min-height: initial;
  }
`;

const fadingStyle = `
  content: '';
  display: block;
  height: 20px;
  pointer-events: none;
  position: absolute;
  width: 100%;
  z-index: 10;
`;

const FadingWrapper = styled.div<Props>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding-top: 1px;
  /* padding-bottom: 1px; */
  position: relative;
  overflow: hidden;

  ${({ withFadingBottom, theme, useBackgroundColor }) =>
    withFadingBottom
      ? `
  &:after {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${
      useBackgroundColor ? theme.ui.layer.backgroundColor : theme.ui.secondLayer.content.backgroundColor
    } 100%);
    bottom: 0;
    ${fadingStyle}
  }
`
      : ''}
  ${({ withFadingTop, theme, useBackgroundColor }) =>
    withFadingTop
      ? `
  &:before {
    background: linear-gradient(180deg, ${
      useBackgroundColor ? theme.ui.layer.backgroundColor : theme.ui.secondLayer.content.backgroundColor
    } 0%, rgba(255, 255, 255, 0) 100%);
    top: 0;
    ${fadingStyle}
  }
`
      : ''}
`;

const VerticalScroller: FunctionalComponent<Props> = ({
  ariaLabel,
  children,
  minHeight,
  useBackgroundColor = false,
  withFadingTop = false,
  withFadingBottom = false,
}) => {
  const content = (
    <VerticalScrollerWrapper
      aria-label={ariaLabel}
      data-testid="uc-vertical-scroller"
      minHeight={minHeight}
      useBackgroundColor={useBackgroundColor}
    >
      {children}
    </VerticalScrollerWrapper>
  );

  return (
    <FadingWrapper
      withFadingBottom={withFadingBottom}
      withFadingTop={withFadingTop}
      useBackgroundColor={useBackgroundColor}
    >
      {content}
    </FadingWrapper>
  );
};

export default VerticalScroller;
